module.exports = __webpack_public_path__ + "img/scopebus@2x.5aae1b71.png";